<template>
	<div>
		<component :is="currentComponent"
			:phenotypesInUse="phenotypesInUse"
			:utilsBox="utilsBox"
			:sectionConfigs="sectionConfigs">
		</component>
		<!-- <cfde-eco-system v-if="component='cfdeEcoSystem'"></cfde-eco-system> -->
		
	</div>
</template>

<script>
import Vue from "vue";
import $ from "jquery";

import cfdeEcoSystem from "@/components/researchPortal/customComponents/cfdeEcoSystem.vue";
import cfdeLanding from "@/components/researchPortal/customComponents/cfdeLanding.vue";
import cfdeDesign from "@/components/researchPortal/customComponents/cfdeDesign.vue";
import cfdeLanding2 from "@/components/researchPortal/customComponents/cfdeLanding2.vue";
import cfdeMechanismDiscovery from "@/components/researchPortal/customComponents/cfdeMechanismDiscovery.vue";
import cfdeExplore from "@/components/researchPortal/customComponents/cfdeExplore.vue";
import FactorBaseReveal from "@/components/researchPortal/customComponents/FactorBaseReveal.vue";
import hybridSearchReveal from "@/components/researchPortal/customComponents/hybridSearchReveal.vue";
import multiQueriesReveal from "@/components/researchPortal/customComponents/multiQueriesReveal.vue";
import revealKgWorkspace from "@/components/researchPortal/customComponents/revealKgWorkspace.vue";
import geneSetCart2KC from "@/components/researchPortal/customComponents/geneSetCart2KC.vue";
import biomarkerNetwork from "@/components/researchPortal/customComponents/biomarkerNetwork.vue";
import revealScope from "@/components/researchPortal/customComponents/revealScope.vue";
import cfdeScope2Design from "@/components/researchPortal/customComponents/cfdeScope2Design.vue";
import cfdeRevealV2 from "@/components/researchPortal/customComponents/cfdeRevealV2.vue";

export default Vue.component("research-section-components", {
	props: ["component", "phenotypesInUse", "utilsBox", "sectionConfigs"],
	components: {
		cfdeEcoSystem,
		cfdeLanding,
		cfdeDesign,
		cfdeLanding2,
		cfdeMechanismDiscovery,
		cfdeExplore,
		FactorBaseReveal,
		hybridSearchReveal,
		multiQueriesReveal,
		revealKgWorkspace,
		geneSetCart2KC,
		biomarkerNetwork,
		revealScope,
		cfdeScope2Design,
		cfdeRevealV2
	},
	data() {
		return {
			currentComponent: null,
		};
	},
	modules: {
	},
	mounted: function () {
console.log('this.component', this.component);
		switch(this.component) {
			case 'cfdeEcoSystem':
				this.currentComponent = cfdeEcoSystem;
				break;
			case 'cfdeLanding':
				this.currentComponent = cfdeLanding;
				break;
			case 'cfdeValidationPlanner'://remove after update
				this.currentComponent = cfdeDesign;
				break;
			case 'cfdeDesign':
				this.currentComponent = cfdeDesign;
				break;
			case 'cfdeLanding2':
				this.currentComponent = cfdeLanding2;
				break;
			case 'cfdeMechanismDiscovery':
				this.currentComponent = cfdeMechanismDiscovery;
				break;
			case 'cfdeGenesValidator'://remove after update
				this.currentComponent = cfdeExplore;
				break;
			case 'cfdeExplore':
				this.currentComponent = cfdeExplore;
				break;
			case 'FactorBaseReveal':
				this.currentComponent = FactorBaseReveal;
				break;
			case 'hybridSearchReveal':
				this.currentComponent = hybridSearchReveal;
				break;
			case 'multiQueriesReveal':
				this.currentComponent = multiQueriesReveal;
				break;
			case 'revealKgWorkspace':
				this.currentComponent = revealKgWorkspace;
				break;
			case 'geneSetCart2KC':
				this.currentComponent = geneSetCart2KC;
				break;
			case 'biomarkerNetwork':
				this.currentComponent = biomarkerNetwork;
				break;
			case 'revealScope':
				this.currentComponent = revealScope;
				break;
			case 'cfdeScope2Design':
				this.currentComponent = cfdeScope2Design;
				break;
			case 'cfdeRevealV2':
				this.currentComponent = cfdeRevealV2;
				break;
		}
	},
	computed: {
		
	},
	watch: {
	},
	methods: {
		
	},
});

$(function () { });
</script>
<style>

</style>
